// include css
import "./css/base.css";

// add event handlers to navbar "office"
document.addEventListener("DOMContentLoaded", function () {
  const qs = window.location.search; // e.g. "?foo=1&bar=2"
  if (!qs) return; // no querystring, no work

  // Find all links that opted in
  document
    .querySelectorAll<HTMLAnchorElement>("a[data-preserve-query]")
    .forEach((a) => {
      const href = a.getAttribute("href");
      if (!href) return;

      // Strip any existing query portion, then re-append the page's
      const [path] = href.split("?");
      a.setAttribute("href", `${path}${qs}`);
    });
});
